<template>
    <div class="news_item">
        <nuxt-link :to="$getArticleLink(article)" class="news_inner block">
            <div class="branch_activity">
                <div class="branch_activity_img_content">
                    <picture
                        v-if="
                            checkIfProperPictureAttached(article.featuredImage)
                        "
                        v-full-image-path="article.featuredImage"
                    />
                    <picture
                        v-else
                        v-full-image-path:assets="'article_image_no_image.svg'"
                    />
                </div>

                <div class="branch_activity_text_contnet">
                    <div class="news_head flex flex_center">
                        <div class="date">
                            {{ date | dateOnly }}
                        </div>
                        <div class="categories_list flex">
                            <nuxt-link
                                v-if="branchName"
                                :to="branchActivitiesLink"
                                class="category_tag"
                                @click.native="$emit('on-branch-select')"
                            >
                                {{ branchName }}
                            </nuxt-link>
                        </div>
                    </div>
                    <div class="news_body">
                        <h3>{{ article.name }}</h3>
                        <p>
                            {{ article.description }}
                        </p>
                    </div>
                </div>
            </div>
        </nuxt-link>
    </div>
</template>

<script>
import checkIfProperPictureAttached from '@/helpers/checkIfProperPictureAttached';

export default {
    props: {
        article: {
            type: Object,
            required: true
        }
    },

    computed: {
        branchName() {
            return this.article.branch?.title;
        },

        branchActivitiesLink() {
            if (!this.article.branch?.slug) {
                return this.localePath('/');
            }

            return this.localePath({
                path: '/branch-activities',
                query: {
                    branches: this.article.branch.slug
                }
            });
        },

        date() {
            const { branchActivityDate, createdAt } = this.article;

            return branchActivityDate || createdAt;
        }
    },

    methods: {
        checkIfProperPictureAttached(image) {
            return checkIfProperPictureAttached(image);
        }
    }
};
</script>
